/**
 * The "Open Positions" buttons on the careers pages. Each opens the external job board in a new
 * tab: `NEXT_PUBLIC_CAREERS_URL_USA` always, and `NEXT_PUBLIC_CAREERS_URL_CANADA` on the Ryerson
 * build only (Southern Tool Steel shows the USA button alone). Both URLs are inlined at build
 * time; an unset variable becomes the link `"undefined"`.
 *
 * Used by the careers heroes and sections: `components/GrowWithSales/Hero/Hero.tsx`,
 * `GrowWithSales/Hero/GrowHeroSTS.tsx`, `GrowWithSales/ImageText/ImageText.tsx`,
 * `WorkingAtRyerson/Hero/Hero.tsx` and `TrainingAndDevelopment/RyersonAcademy/RyersonAcademy.tsx`.
 */
import React from "react";
import { Button } from "@ryerson/frontend.button";
import { Flex } from "@ryerson/frontend.layout";
import { Link } from "@ryerson/frontend.navigation";
import { useApplication } from "@ryerson/frontend.application";
import { CareerButtonsContent } from "./Content";
import { Company } from "@ryerson/common.enums";

/** Renders the job-board buttons for the current brand and language (English fallback). */
export const CareersButtons: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	const content = CareerButtonsContent[language] || CareerButtonsContent.en;

	const isRyerson = process.env.NEXT_PUBLIC_COMPANY === Company.RYERSON;
	return (
		<Flex direction="column" css={{ width: "197px", gap: "20px" }}>
			<Link to={`${process.env.NEXT_PUBLIC_CAREERS_URL_USA}`} target={"_blank"} next={false}>
				<Button
					label={content.careerButtonUSA}
					type="primary"
					shape="rounded"
					paddingType="relaxed"
					onClick={() => {}}
					size="sm"
					fullwidth
				/>
			</Link>

			{isRyerson && (
				<Link
					to={`${process.env.NEXT_PUBLIC_CAREERS_URL_CANADA}`}
					target={"_blank"}
					next={false}
				>
					<Button
						label={content.careerButtonCanada}
						type="secondary"
						shape="rounded"
						paddingType="relaxed"
						onClick={() => {}}
						size="sm"
						fullwidth
					/>
				</Link>
			)}
		</Flex>
	);
};
